import { getData, postData, putData } from "adminApi/apiClient";

const API_URL = `duty-shift`;

// --- SHIFT API ---
export const getShiftList = async (
  { page = 1, limit = 10, search = "" },
  signal = null,
) => {
  try {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search: search,
    });

    const result = await getData(
      `${API_URL}/list?${queryParams}`,
      {},
      {},
      signal,
    );
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error("Get Shift List API error:", error);
    return {
      success: false,
      ...error,
    };
  }
};

export const createShift = async ({ data }) => {
  try {
    const result = await postData(`${API_URL}/add`, data);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error("shift add API error:", error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.data.error : error.message,
        status: error.status,
      },
    };
  }
};

export const updateShift = async ({ id, data }) => {
  try {
    const result = await putData(`${API_URL}/update/${id}`, data);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error("Update Shift API error:", error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.data?.error : error.message,
        status: error.status,
      },
    };
  }
};

export const getShiftById = async (id) => {
  try {
    const result = await getData(`${API_URL}/${id}`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get Shift by ID API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};
// --- EXTERNAL DATA ---
